'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = require('preact');

var _client = require('../../../client.js');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUploadButton = function (_Component) {
  _inherits(FileUploadButton, _Component);

  function FileUploadButton(props) {
    _classCallCheck(this, FileUploadButton);

    var _this = _possibleConstructorReturn(this, (FileUploadButton.__proto__ || Object.getPrototypeOf(FileUploadButton)).call(this));

    _this.state = {};
    _this.updateFiles = _this.updateFiles.bind(_this);
    return _this;
  }

  _createClass(FileUploadButton, [{
    key: 'updateFiles',
    value: function updateFiles(event) {
      var _this2 = this;

      var name = event.target.name;
      var files = event.target.files;
      _client2.default.upload(this.props.folder.id, files).then(function (got_files) {
        _this2.props.addFiles(got_files);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _preact.h)(
        'div',
        { 'class': 'fileUploadButton' },
        (0, _preact.h)('input', { type: 'file', multiple: true, name: 'files', onChange: this.updateFiles }),
        (0, _preact.h)(
          'span',
          null,
          '+ upload'
        )
      );
    }
  }]);

  return FileUploadButton;
}(_preact.Component);

exports.default = FileUploadButton;


//////////////////
// WEBPACK FOOTER
// ./client/components/Browser/Files/FileUploadButton.jsx
// module id = 80
// module chunks = 0